"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Doc = exports.Sheet = void 0;
exports.fetchSheet = fetchSheet;
const dates = require("../dates");
const grid = require("../grid");
const sheets = require("../sheets");
//const URL = "https://localhost/apps/test/lineups.html";
const kLineupsUrl = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTCwix0XM4Ijxb7Q7K-wBG7E-l0cqsRZ9ifDhtYRVOiRZSo-JP6fiM0xBO9HSYo14f1wcw3TA_L333l/pubhtml';
function getLineupsUrl(params) {
    const overrideUrl = new URLSearchParams(params).get('lineupsUrl');
    if (overrideUrl) {
        return overrideUrl;
    }
    return kLineupsUrl;
}
async function fetchSheet() {
    return fetch(getLineupsUrl(window.location.hash.substring(1))).then(r => r.text());
}
function getUnique(eventData, name) {
    const values = eventData.get(name);
    if (!values) {
        console.error('eventData', eventData);
        throw Error(`eventData ${name} missing from ${eventData.toString()}`);
    }
    if (values?.length != 1) {
        throw Error(`eventData ${name} is not unique: ${values}`);
    }
    return values[0];
}
class Sheet {
    constructor(grid) {
        this.timezone = new dates.Timezone(9);
        this.grid = grid;
    }
    findMandatory(text) {
        const ref = grid.findCell(this.grid, sheets.textTest(text));
        if (!ref) {
            throw `No '${text}' row`;
        }
        return ref;
    }
    extractDateCols() {
        const ref = this.findMandatory('Date');
        return grid.collectHorizontal(this.grid, sheets.regexpTest(/^\s*20\d\d-\d\d-\d\d\s*$/), ref);
    }
    extractItemRows() {
        const ref = this.findMandatory('Item');
        return grid.collectVertical(this.grid, sheets.regexpTest(/^.+$/), ref.nextRow());
    }
    findBlocks(items) {
        const blocks = [];
        let start;
        let previous;
        for (const item of items) {
            if (item.get(this.grid).textContent == 'Title') {
                if (start && previous) {
                    blocks.push({ start: start, end: previous });
                }
                start = item;
            }
            previous = item;
        }
        if (start && previous) {
            blocks.push({ start: start, end: previous });
        }
        return blocks;
    }
    getPair(ref) {
        return [
            sheets.getTrimmed(ref.get(this.grid)),
            sheets.getTrimmed(ref.nextColumn().get(this.grid)),
        ];
    }
    extractDefaults(items) {
        const defaults = new Map();
        for (const item of items) {
            const [name, value] = this.getPair(item);
            defaults.set(item.row, {
                name: name,
                value: value,
            });
        }
        return defaults;
    }
    makeEvent(eventData, date) {
        const startTime = getUnique(eventData, 'Start Time').value1;
        const title = getUnique(eventData, 'Title').value1;
        const roles = [];
        for (const roleData of eventData.get('Role') || []) {
            roles.push({
                description: roleData.value1 || '',
                person: roleData.value2 || '',
            });
        }
        return {
            title: title,
            date: date,
            startTime: (startTime.length == 4 ? '0' : '') + startTime,
            roles: roles.filter(role => role.person),
        };
    }
    event(dates, blocks) {
        const events = [];
        for (const date of dates) {
            const dateString = date.get(this.grid).textContent;
            if (!dateString) {
                throw Error('No date string');
            }
            for (const block of blocks) {
                try {
                    const eventData = new Map();
                    for (let ref = block.start; ref.row <= block.end.row; ref = ref.nextRow()) {
                        const [name, def] = this.getPair(ref);
                        const eventRef = ref.with(date.col);
                        const [value1, value2] = this.getPair(eventRef);
                        if (value1 === null) {
                            throw Error(`No value for ${eventRef.toString()}`);
                        }
                        if (!eventData.has(name)) {
                            eventData.set(name, []);
                        }
                        const eventDatum = {
                            value1: value1 || def,
                            value2: value2,
                        };
                        eventData.get(name)?.push(eventDatum);
                    }
                    events.push(this.makeEvent(eventData, dateString));
                }
                catch (e) {
                    console.error('Exception handling Block', e, block);
                }
            }
        }
        return events;
    }
    extractEvents() {
        const dates = this.extractDateCols();
        const items = this.extractItemRows();
        const blocks = this.findBlocks(items);
        const events = this.event(dates, blocks);
        const realEvents = events.filter(e => e.roles.length > 0);
        console.log(realEvents);
        return realEvents;
    }
}
exports.Sheet = Sheet;
class Doc {
    constructor(html) {
        this.document = new DOMParser().parseFromString(html, 'text/html');
    }
    extractEvents() {
        const events = [];
        for (const table of sheets.extractTables(this.document)) {
            const g = sheets.tableToGrid(table);
            if (!grid.findCell(g, sheets.textTest('Item'))) {
                continue;
            }
            const sheet = new Sheet(g);
            events.push(...sheet.extractEvents());
        }
        return events;
    }
}
exports.Doc = Doc;
